export const CALCULATOR_FACT_KEY_FIELDS = Object.freeze({
    groupMembership: Object.freeze(["kind", "fishingSource", "itemId", "groupId"]),
    groupPresence: Object.freeze(["kind", "fishingSource", "groupId"]),
    optionSelectionRule: Object.freeze(["kind", "optionId"]),
    itemPresence: Object.freeze(["kind", "fishingSource", "itemId"]),
    itemRate: Object.freeze([
        "kind",
        "fishingSource",
        "itemId",
        "groupId",
        "branchId",
    ]),
    itemQuantity: Object.freeze(["kind", "fishingSource", "itemId", "groupId"]),
    itemQuantityDefault: Object.freeze(["kind", "itemId"]),
    groupRate: Object.freeze(["kind", "fishingSource", "groupId", "branchId"]),
    itemPrice: Object.freeze(["kind", "itemId"]),
    tradeCurve: Object.freeze(["kind", "itemId"]),
    itemEffect: Object.freeze(["kind", "subject", "effect"]),
    petOption: Object.freeze(["kind", "petId", "tier", "optionId", "optionKind"]),
    tradeFact: Object.freeze(["kind", "fact"]),
    refuteEvidence: Object.freeze(["kind", "targetFactId"]),
    fishingSourceBiteTime: Object.freeze(["kind", "fishingSource"]),
    masteryPrizeRate: Object.freeze(["kind", "mastery"]),
    durabilityReduction: Object.freeze(["kind", "lifeskillLevel"]),
    itemIdentity: Object.freeze(["kind", "itemId"]),
    itemExperience: Object.freeze(["kind", "itemId"]),
});

export function validateCalculatorFactKeyShapeV1(value, path, contract) {
    const key = contract.requireRecord(value, path);
    const kind = contract.requireString(key.kind, `${path}.kind`);
    const fields = CALCULATOR_FACT_KEY_FIELDS[kind];
    if (!fields) {
        contract.fail(`${path}.kind`, `unsupported fact kind ${kind}`);
    }
    return contract.requireExactFields(key, fields, path);
}
